import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { saveUserConnected } from '../../store/user/userActions';
import shopApi from '../../api/shop';
import theme from '../../data/theme';
import { withRouter } from 'react-router-dom';
import { toast } from "react-toastify";

function AccountPageLogin({ history }) {
    const dispatch = useDispatch();
    const userConnected = useSelector((state) => state.user.userConnected);
    const user = userConnected?.user;
    const userId = user?.id;

    const [formData, setFormData] = useState({
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        email: user?.email || '',
        phone: user?.phone || ''
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value
        }));
    };

    const validate = () => {
        const newErrors = {};

        if (!formData.firstName.trim()) newErrors.firstName = "First Name is required.";
        if (!formData.lastName.trim()) newErrors.lastName = "Last Name is required.";
        if (!formData.email.trim()) {
            newErrors.email = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Invalid email format.";
        }
        if (!formData.phone.trim()) newErrors.phone = "Phone is required.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validate()) return;

        try {
            const response = await shopApi.updateUser(formData, userId);
            const updatedUserConnected = {
                ...userConnected,
                user: response
            };
            dispatch(saveUserConnected(updatedUserConnected));
            toast.success("Utilisateur modifié avec succès", {
                theme: "colored",
                autoClose: 20000,
            });
        } catch (error) {
            console.error('Update failed', error);
        }
    };

    return (
        <div className="card">
            <Helmet>
                <title>
                    {`My Account - ${theme.name}`}
                </title>
            </Helmet>

            <div className="card-header">
                <h5><FormattedMessage id="Account.profile" defaultMessage="Edit profil" /></h5>
            </div>
            <div className="card-divider" />
            <div className="card-body">
                <div className="row no-gutters">
                    <div className="col-12 col-lg-10 col-xl-8">
                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label htmlFor="firstName"><FormattedMessage id="Account.firstName" /></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                                    id="firstName"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                />
                                {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
                            </div>
                            <div className="form-group col-md-12">
                                <label htmlFor="lastName"><FormattedMessage id="Account.lastName" /></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
                                    id="lastName"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                />
                                {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label htmlFor="email"><FormattedMessage id="Account.email" /></label>
                                <input
                                    type="email"
                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                    id="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </div>

                            <div className="form-group col-md-12">
                                <label htmlFor="phone"><FormattedMessage id="Account.phone" /></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                    id="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                                {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                            </div>
                        </div>

                        <div className="form-group mt-3 mb-0">
                            <button className="btn btn-primary" type="button" onClick={handleSubmit}><FormattedMessage id="Account.save" /></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(AccountPageLogin);
